import { useSubscription } from '@rta/rta-blueprint-library';

import { Controller } from '@context';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

type IslandFDimensionsFeatureParams = FeatureHoookParams;
export const useShowIslandDimensionFeature = (_params: IslandFDimensionsFeatureParams = {}): Feature<boolean> => {
	const [controller] = useDesign<Controller, { options: { showIslandBaseDimensions: boolean }}>();

	useSubscription(controller, false, [['layer-option-island-base-dimension', '*']]);

	const controllerSupportsFeature = (controller?.options?.showIslandBaseDimensions ?? null) !== null;
	const showLayer = controller?.options?.showIslandBaseDimensions ?? true;

	const tooltip = (() => {
		const showHide = showLayer ? lang.layer.tooltip.hide : lang.layer.tooltip.show;
		return `${showHide} ${lang.layer.label.islandDimensions} ${lang.layer.layer}`;
	})();

	return {
		name: 'showIslandDimensions',
		label: lang.layer.label.islandDimensions,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <></>,
		disabled: !controllerSupportsFeature,
		value: showLayer,
		hidden: false,
		handler: () => {
			if (controller) {
				controller.options.showIslandBaseDimensions = !showLayer;
			}
		}
	};
};
